import './PostPlanCard.scss';

import { ProductOffering } from '@travelwin/core';
import { ACTION_VIA_SOURCE_TYPE } from '@/analytics';
import ClickablePlanCardContainer from '../PlanCard/ClickablePlanCardContainer';
const className = 'c-PostPlanCard';

type PostPlanCardProps = {
  plan: ProductOffering;
  actionViaSource?: ACTION_VIA_SOURCE_TYPE;
};

export const PostPlanCard = ({ plan, actionViaSource }: PostPlanCardProps) => {
  return (
    <div className={className}>
      <ClickablePlanCardContainer
        planDetails={plan}
        fluid
        actionViaSource={actionViaSource}
      />
    </div>
  );
};
